import { createTheme } from '@mui/material';

export const theme = createTheme({
  // set up theme
  palette: {
    primary: {
      main: 'rgba(113, 184, 190, 1)'
    },
    secondary: {
      main: 'rgba(113, 184, 190, 1)'
    },
    success: {
      main: 'rgba(56, 178, 140, 1)'
    },
    error: {
      main: 'rgba(255, 90, 50, 1)'
    }
  },
  components: {
    MuiCard: { defaultProps: { sx: { backgroundColor: 'none', boxShadow: 'none' } } },
    MuiButton: { defaultProps: { sx: { textTransform: 'none' } } },
    MuiButtonBase: { defaultProps: { sx: { textTransform: 'none' } } },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        size: 'small',
        sx: {
          backgroundColor: '#fff',
          width: '100%',
          maxWidth: '100%',
          margin: 'auto',
          marginBottom: '1rem',
          textAlign: 'left',
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'rgba(0, 0, 0, 0.6)'
        }
      }
    }
  },

  typography: {
    body2: {
      fontSize: '13px',
      color: 'rgba(146, 154, 163, 1)'
    },
    body1: {
      fontSize: '14px',
      color: 'rgba(43, 43, 43, 1)'
    },
    h1: {
      fontSize: '32.53px',
      textAlign: 'center',
      width: '15rem',
      '@media (min-width:900px)': {
        fontSize: '50px',
        width: '35rem'
      }
    }
  }
});
